module.exports = __webpack_public_path__ + "static/media/r130.6fc96cad.jpg";